import * as types from "../types";

const initialState = {
    loading: false,
    accessToken: null,
    auction_name: null,
    start_date: null,
    end_date: null,
    file: null,
    auction_group:null,
    createAuctionResult: null,
    error: null
}

export default function createAuctionReducer(state = initialState, action){
    
    switch(action.type){
 
        case types.CREATE_AUCTION_REQUEST :
            console.log("create",action);
        return{
                ...state,
                loading: true,
                accessToken: action.payload.accessToken,
                auction_name: action.payload.auction_name,
                start_date: action.payload.start_date,
                end_date: action.payload.end_date,
                file: action.payload.file,
                auction_group:action.payload.auction_group,
            }

        case types.CREATE_AUCTION_SUCCESS :
            return{
                ...state,
                loading: false,
                createAuctionResult: action.payload.createAuctionResult,
            }

        case types.CREATE_AUCTION_FAILURE :
            return{
                ...state,
                loading: false,
                accessToken: null,
                auction_name: null,
                start_date: null,
                end_date: null,
                file: null,
                auction_group:null,
                createAuctionResult: null,
                error: action.payload.error
            }

        case types.CREATE_AUCTION_RESET :
                return{
                    loading: false,
                    accessToken: null,
                    auction_name: null,
                    start_date: null,
                    end_date: null,
                    file: null,
                    auction_group:null,
                    createAuctionResult: null,
                    error: null
                }
    

        default :
        return state;

    }

}